import React from 'react';

const teamMembers = [
  {
    name: 'Hamza',
    positions: ['Game Design', 'C++',"Systems", "AI"],
    avatar: 'https://api.dicebear.com/9.x/croodles/svg?seed=Riley&beardProbability=80',
    description: 'Converting caffeine into code one bug at a time. My motto? "If it compiles, it ships!" You might catch me debugging at 3 AM with my trusty coffee mug, turning impossible bugs into "just another feature"',
    discord: '577922095523299339'
  },
  {
    name: 'Ammar',
    positions: ['AI','Combat', 'Blueprints'],
    avatar: 'https://api.dicebear.com/9.x/croodles/svg?seed=Eden&beardProbability=80',
    description: 'The master chef of blueprint spaghetti, serving up perfectly tangled node connections that somehow create pure gaming magic. My blueprints might look like meatball carbonara, but every noodle has its purpose!',
    discord: '1003776077111496704'
  },
  {
    name: 'Abdulahad',
    positions: ['3D', 'Concept Art'],
    avatar: 'https://api.dicebear.com/9.x/croodles/svg?seed=Valentina&beardProbability=80',
    description: 'My job is mostly about staring at a screen and hoping the computer doesn\'t crash. Oh, and also fighting with UV unwrapping. Don\'t even get me started on rigging. But hey, at least the models look cool... from certain angles... in specific lighting... if you squint a bit',
    discord: '1057179318641496144'
  }
];

function Team() {
  return (
    <section className="team" id="team">
      <div className="title">
        <lord-icon
          src="https://cdn.lordicon.com/ibgjiwvi.json"
          trigger="loop"
          colors="primary:#962f2f,secondary:#ffffff"
          style={{width: '50px', height: '50px'}}
        ></lord-icon>
        <h2 className="title-text">Our <span>Team</span></h2>
        <p>Meet the creative minds behind Midnight Ghoul Games</p>
      </div>
      <div className="content">
        {teamMembers.map((member, index) => (
          <div 
            key={index} 
            className="team-member" 
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="member-image">
              <img 
                src={member.avatar}
                alt={member.name}
              />
            </div>
            <div className="member-info">
              <h3>{member.name}</h3>
              <div className="position-tags">
                {member.positions.map((position, i) => (
                  <span key={i} className="position-tag">{position}</span>
                ))}
              </div>
              <p>{member.description}</p>
              <div className="member-social">
                <a
                  href={`https://discord.com/users/${member.discord}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                  title={`Add on Discord: ${member.discord}`}
                >
                  <box-icon name='discord-alt' type='logo' color="#ffffff"></box-icon>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Team;